var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright"},[_vm._v(" "+_vm._s(("©1998-" + _vm.year + " 弘成科技发展有限公司 版权所有"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }